export const CameraRoll = {
  getPhotos: (_params) => Promise.resolve({ edges: [], page_info: { has_next_page: false } }),
  save: (_tag, _options) => Promise.reject(new Error('CameraRoll.save is not supported on web')),
  deletePhotos: (_photoUris) => Promise.reject(new Error('CameraRoll.deletePhotos is not supported on web')),
  getAlbums: (_params) => Promise.resolve([]),
};
